// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\EmailSentResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type EmailSentApiResponse = {
	id: number;
	template: string;
	date_sent: string;
	email: string;
	account: string | null;
	variables: Record<string, string> | null;
};

export type EmailSent = {
	id: number;
	template: string;
	date_sent: DateTime;
	email: string;
	account: string | null;
	variables: Record<string, string> | null;
};

export function hydrateEmailSent(data: EmailSentApiResponse): EmailSent {
	return {
		...data,
		date_sent: DateTimefromISO(data.date_sent)!,
		variables: Array.isArray(data.variables) ? {} : data.variables,
	};
}